module.exports = __webpack_public_path__ + "img/Mendoza-Fiduciaria-logo.305addc0.png";